/**
 * SAL1030_R01 - 품목별 수주 현황 조회
 * Container 컴포넌트 (메인 레이아웃)
 */

import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useSAL1030_R01Store } from "./Store_SAL1030_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_SAL1030_R01 } from "./Content_SAL1030_R01";
import { SearchSection_SAL1030_R01 } from "./SearchSection_SAL1030_R01";
import { Table_SAL1030_R01 } from "./Table_SAL1030_R01";
import { SAL1030_R01Dto } from "./Dto_SAL1030_R01";

/**
 * 품목별 수주 현황 조회 컨테이너 컴포넌트
 * 품목별 수주 현황 조회 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_SAL1030_R01 = () => {
  const { initData } = useSAL1030_R01Store();
  const { setMessage } = useUiuxStore();
  
  const gridRef = useRef<AgGridReact<SAL1030_R01Dto>>(null);

  // Content에서 액션바 핸들러 함수들을 가져옴
  const { fetchData, handleExcelClick } = Content_SAL1030_R01({
    setMessage,
  });

  return (
    <div className="content-container">
      <Actionbar
        onFetchClick={fetchData}
        onSaveClick={undefined}
        onDeleteClick={undefined}
        onInitClick={initData}
        onExcelClick={handleExcelClick}
        onPrintClick={undefined}
      />

      {/* 검색 섹션 */}
      <SearchSection_SAL1030_R01 />

      <div className="flex flex-1 p-[12px] gap-[4px] min-h-0">
        <div className="h-full w-full">
          {/* 품목별 수주 현황 테이블 */}
          <Table_SAL1030_R01 gridRef={gridRef} />
        </div>
      </div>

      {/* 메시지 표시 컴포넌트 */}
      <Message />
    </div>
  );
};

export default Container_SAL1030_R01;

